import React, { Component } from 'react';
import { Row, Col } from 'react-bootstrap';
import { withRouter } from 'react-router-dom';
import history from '../../../utils/history';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { compose } from 'underscore';

import BZCarousel from 'web-common/bizzabo-components/components/BZCarousel';
import FeatureToggleUtils from 'FeatureToggleUtils';
import config from 'config';

import { sendAnalytics } from 'utils/analyticsUtils';
import SessionsFilter from './SessionsFilter';
import SelectedTags from './SelectedTags';
import SearchAgenda from './SearchAgenda';
import { getInternalWebsiteBaseUrl } from 'web-common/scripts/utils/whitelabelUtils';
import {
    XXS_WIDTH,
    XS_WIDTH,
    S_WIDTH,
    M_WIDTH,
    L_WIDTH,
    XL_WIDTH,
    VIEW_MODE_LIST,
    VIEW_MODE_SBS,
    loginClickOrigin,
    loginSpinnerOrigin,
} from '../../../constants/Enums';
import { getScreenWidth } from '../../Utils';
import TicketSelect from './TicketSelect';
import {
    sendCustomClick
} from '../../../utils/SnowplowUtils';
import {
    buttonTypes,
    loginSubCategory
} from '../../../constants/SnowplowConst';

const NextArrow = (props) => {
    const {className, style, onClick} = props;
    return (
        <div
            className={`custom-color color-1 ${className}`}
            style={{...style, display: 'block'}}
            onClick={onClick}
        ><i className="fa icon-AgendaAtt_arrow"/></div>
    );
};

const PrevArrow = (props) => {
    const {className, style, onClick} = props;
    return (
        <div
            className={`custom-color color-1 ${className}`}
            style={{...style, display: 'block'}}
            onClick={onClick}
        ><i className="fa icon-AgendaAtt_arrow mirror"/></div>
    );
};

const TABS_PADDING = 15;

const sliderSettings = {
    responsive: [
        { breakpoint: XXS_WIDTH, settings: { slidesToShow: 2 } },
        { breakpoint: XS_WIDTH, settings: { slidesToShow: 3 } },
        { breakpoint: S_WIDTH, settings: { slidesToShow: 4 } },
        { breakpoint: M_WIDTH, settings: { slidesToShow: 5 } },
        { breakpoint: L_WIDTH, settings: { slidesToShow: 7 } },
        { breakpoint: XL_WIDTH, settings: { slidesToShow: 8 } },
    ],
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />
};

class AgendaSearch extends Component {
    prevHeight = 0;

    static propTypes = {
        settings: PropTypes.object.isRequired,
        selectedDays: PropTypes.array.isRequired,
        agendaDays: PropTypes.array.isRequired,
        selectDay: PropTypes.func.isRequired,
        filterProps: PropTypes.object.isRequired,
        searchAgendaSessions: PropTypes.func.isRequired,
        searchBySpeaker: PropTypes.func.isRequired,
        clientNavigationAction: PropTypes.func.isRequired,
        event: PropTypes.object.isRequired,
        selectedTags: PropTypes.shape({
            tags: PropTypes.array.isRequired,
            clearAllTags: PropTypes.func.isRequired
        }),
        setSearchContainerHeight: PropTypes.func.isRequired,
        changeViewMode: PropTypes.func.isRequired,
        viewMode: PropTypes.string.isRequired,
        isWebLoginV2Used: PropTypes.bool,
        isLiveNowBannerOpen: PropTypes.bool
    };

    state = {
        isClientSideRendered: typeof document !== 'undefined' && typeof window !== 'undefined',
        isNewWebLoginLoading: false
    };

    updateDimensions = () => this.setState({shouldRenderCarousel: getScreenWidth()});

    componentDidMount = () => {
        this.updateDimensions();
    };

    componentDidUpdate = (prevProps) => {
        const { setSearchContainerHeight } = this.props;

        const height = this.divElement != null ? this.divElement.clientHeight + TABS_PADDING: 0;

        if (height !== this.prevHeight) {
            this.prevHeight = height;
            setSearchContainerHeight(height);
        }
    };

    selectDay = (e) => {
        this.props.selectDay(e.target.value);
    };

    shouldRenderCarousel = () => {
        const { agendaDays } = this.props;
        const screenWidth = getScreenWidth();

        const currentDevice = sliderSettings.responsive.find(device => screenWidth <= device.breakpoint);

        return agendaDays.length + 1 > currentDevice.settings.slidesToShow;
    };

    renderDay = (index, label, value, cls = '', selectedCls = '') => (
        <div key={index} className='day-button-container'>
            <div className='day-button-wrapper'>
                <div className='day-button-wrapper-inner'>
                    <button
                        className={`day-elems ${cls} ${selectedCls}`}
                        onClick={this.selectDay}
                        value={value}
                    >
                        {label}
                    </button>
                    <div className={`day-elem-border custom-color color-1-background ${selectedCls}`} />
                </div>
            </div>
        </div>
    );

    renderSlides = () => {
        const { selectedDays, agendaDays, settings: { datesLabelType, datesLabelMapping }} = this.props;
        const isAllDaysSelected = selectedDays.length === agendaDays.length;
        const customClassWithColor = 'selected custom-color color-1';
        const selectedCls = isAllDaysSelected ? customClassWithColor : '';
        const isDatesLabelsEnabled = datesLabelType === 'LABELS';
        const allDaysLabel = isDatesLabelsEnabled ? datesLabelMapping['all-days']: 'All Days';
        return [
            this.renderDay(0, allDaysLabel, 'ALL', 'all-days', selectedCls ),
            ...agendaDays.map(({label, value}, index) => {
                const dateLabel = isDatesLabelsEnabled ? datesLabelMapping[`day-${value}`] : label;
                const selectedCls = selectedDays.includes(value) && !isAllDaysSelected ? customClassWithColor: '';
                return this.renderDay(++index, dateLabel, value, '', selectedCls);
            })
        ];
    };

    searchAgenda = async(search) => {
        const { settings: { eventId }, searchAgendaSessions, searchBySpeaker } = this.props;
        return await Promise.all([
            searchBySpeaker(search),
            searchAgendaSessions(search)
        ])
            .catch(err => console.log(err))
            .then(([speakers, sessions]) => ({ speakers: (speakers || []), sessions: ((sessions || {}).sessions || []) }));
    }

    selectSearchResult = ({ speaker, session }) => {
        const { siteConf: { isWidget }, clientNavigationAction, event, toggleTag } = this.props;
        if (speaker) {
            toggleTag('speakers', speaker.id);
        } else {
            const isWidgetParam = isWidget ? '?widget=true' : '';
            const url = getInternalWebsiteBaseUrl(event, `agenda/session/${session.id}${isWidgetParam}`);
            clientNavigationAction();
            history.push(url);
        }
    };

    viewButtonClickHandler = (e) => {
        this.props.changeViewMode(e.currentTarget.value);
    };

    handleLoginLogout = (e) => {
        const {
            isLoggedInUser,
            onLogin,
            onLogout,
            setLoginV2OffsetTop,
            siteConf: { isWidget },
            isWebLoginV2Used,
            setLoginV2SpinnerOrigin,
        } = this.props;
        if (!isLoggedInUser) {
            sendCustomClick(buttonTypes.login, loginSubCategory.agendaGeneralLogin, e.currentTarget);
            sendAnalytics('loginClick', {
                clickOrigin: loginClickOrigin.agenda.login
            });
            const isLoginOnEmbedded = isWebLoginV2Used && isWidget && window.self !== window.parent;
            if (isLoginOnEmbedded) {
                setLoginV2OffsetTop?.(e.pageY);
            }
            onLogin?.();
            setLoginV2SpinnerOrigin?.(loginSpinnerOrigin.AGENDA_LOGIN);
        } else {
            onLogout?.();
        }
    };

    render() {
        const {
            agendaDays,
            filterProps,
            selectedTags,
            siteConf,
            settings,
            siteConf: { color1 },
            viewMode,
            isLoggedInUser,
            event,
            loginV2LoadingState,
            isLiveNowBannerOpen,
            isRingWorks
        } = this.props;

        const { isClientSideRendered } = this.state;

        const shouldShowViewButtons = !settings.views || settings.views.length > 1;

        const isLoginV2Loading = loginV2LoadingState.isLoading
            && loginV2LoadingState.spinnerOrigin === loginSpinnerOrigin.AGENDA_LOGIN;

        const loginLogoutBtnStyles = classnames('cta-button cta-button-medium font-size-13 custom-color', {
            'color-1-background color-1-hover-opacity': !isLoggedInUser,
            'color-1 color-1-border color-1-hover-opacity-outline': isLoggedInUser,
            'with-spinner': isLoginV2Loading,
        });

        const isAgendaLoginFlowEnabled = !FeatureToggleUtils.isFeatureEnabled('oldLogin') && !isRingWorks;

        return (
            <div className='agenda-search'>
                <Row className='search-row'>
                    <Col xs={8} sm={5} md={6} className="padding-right-none search-session">
                        <SearchAgenda
                            searchAgenda={this.searchAgenda}
                            siteConf={siteConf}
                            settings={settings}
                            onSelect={this.selectSearchResult}
                            event={event}
                            isLiveNowBannerOpen={isLiveNowBannerOpen}
                        />
                    </Col>
                    <Col xs={2} sm={3} lg={2} className='search-input'>
                        <SessionsFilter {...filterProps} color={`var(--page-main-color, ${color1})`}/>
                    </Col>
                    {isLoggedInUser ?
                        <TicketSelect container={this} sbsShow={shouldShowViewButtons} />
                        : null}
                </Row>
                {shouldShowViewButtons
                    ? <div className={classnames(
                        'view-buttons-container',
                        {'is-pull-left': isAgendaLoginFlowEnabled }
                    )}>
                        <button
                            className={classnames('view-button', {
                                'view-button-active': viewMode === VIEW_MODE_LIST
                            })}
                            value={VIEW_MODE_LIST}
                            onClick={this.viewButtonClickHandler}>
                            <i className={classnames('icon icon-AgendaAtt_list', {
                                'custom-color color-1': viewMode === VIEW_MODE_LIST,
                                'agenda-light-gray': viewMode !== VIEW_MODE_LIST

                            })}/>
                        </button>

                        <button
                            className={classnames('view-button', {
                                'view-button-active': viewMode === VIEW_MODE_SBS
                            })}
                            value={VIEW_MODE_SBS}
                            onClick={this.viewButtonClickHandler}>
                            <i className={classnames('icon icon-AgendaAtt_sideByside', {
                                'custom-color color-1': viewMode === VIEW_MODE_SBS,
                                'agenda-light-gray': viewMode !== VIEW_MODE_SBS
                            })}/>
                        </button>
                    </div>
                    : null
                }
                {isAgendaLoginFlowEnabled && (
                    <div className="login-buttons-container">
                        <button
                            className={loginLogoutBtnStyles}
                            onClick={this.handleLoginLogout}>
                            {isLoggedInUser
                                ? 'Logout'
                                : isLoginV2Loading
                                    ? <i className="fa fa-spinner fa-spin font-size-22" />
                                    : 'Log in'}
                        </button>
                    </div>
                )}
                { !!selectedTags.tags.length &&
                    <div ref={(divElement) => this.divElement = divElement}>
                        <Row className="selected-tags-row margin-bottom-small">
                            <Col className="selected-tags-col col-md-10 col-xs-12">
                                <SelectedTags {...selectedTags} color={color1}/>
                            </Col>
                        </Row>
                    </div>
                }
                <Row>
                    <Col className="agenda-separator col-md-12 col-xs-12" />
                </Row>
                {
                    agendaDays.length === 1 || !isClientSideRendered
                        ? null :
                        <div>
                            <Row className='days-row margin-vertical-xs'>
                                <Col xs={12} md={12}>
                                    {
                                        this.shouldRenderCarousel()
                                            ? <BZCarousel settings={sliderSettings}>{this.renderSlides()}</BZCarousel>
                                            : this.renderSlides()
                                    }
                                </Col>
                            </Row>
                            <Row>
                                <Col className="agenda-separator col-md-12 col-xs-12" />
                            </Row>
                        </div>
                }
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    isRingWorks: state.ringReducer.isRingWorks
});

export default compose(
    withRouter,
    connect(mapStateToProps)
)(AgendaSearch);
